module.exports = __webpack_public_path__ + "r-v3/img/ml_11_01.4b5146f2.jpg";